import type { VoidComponent } from "solid-js";
import { useTranslation } from "../../../../../state/i18n";
import SettingSection from "../../components/SettingSection";
import { TextButton } from "../../../../../components/button/Button.tsx";
import { noop } from "lodash-es";
import { Translation } from "../../../../../utils/Translation.tsx";
import { keyFromSelector } from "i18next";
import TextLink from "../../../../../components/link/TextLink.tsx";

// TODO: DEV-8326
const CancelSection: VoidComponent = () => {
  const { t } = useTranslation();

  return (
    <SettingSection
      ariaIdPrefix="cancel"
      title={t(($) => $.SETTINGS_BILLING_CANCEL_PLAN_TITLE)}
      description={
        <Translation
          key={keyFromSelector(($) => $.SETTINGS_BILLING_CANCEL_PLAN_DESCRIPTION)}
          components={{
            contactUsLink: (props) => <TextLink isExternal href={props.href} label={props.label} />,
          }}
        />
      }
    >
      <TextButton
        text={t(($) => $.SETTINGS_BILLING_CANCEL_PLAN_CANCEL_BUTTON)}
        variant="secondary"
        color="destructive"
        class="ml-auto"
        onClick={noop}
      />
    </SettingSection>
  );
};

export default CancelSection;
